import React, { useEffect, useState } from 'react'
import jwt_decode from "jwt-decode";
import Navbar from '../../Navbar'
import axios from 'axios';
import baseUrl from "../../BaseUrl";
import Loader from "../../Loader";
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../../Header';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Select from 'react-select';
import TrendAnalysisChart from './TrendAnalysisChart';

const ENRMSSummaryComparison = () => {
    const location = useLocation();
    const { compid, type, carrier,filter, batch_id, persistedState } = location.state || {};

    const [name, setName] = useState('');
    const [cid, setCid] = useState('')
    const [token, setToken] = useState('');
    const [expire, setExpire] = useState('');
    const [role, setRole] = useState('');
    const [access, setAccess] = useState([]);
    const [company, setCompany] = useState([]);
    const [popupOpen, setPopupOpen] = useState(false);
    const [casAccess, setCASAccess] = useState(false);
    const [selectedValue, setSelectedValue] = useState(persistedState?.selectedValue || compid);    const [showNoAccessMessage,setShowNoMessageAccess] = useState(false);
    const [searchDate, setSearchDate] = useState(persistedState?.searchDate || "");
    const [searchEndDate, setSearchEndDate] = useState(persistedState?.searchEndDate || "");
    const [displayDate, setDisplayDate] = useState(persistedState?.displayDate ? new Date(persistedState.displayDate) : "");
    const [displayEndDate, setDisplayEndDate] = useState(persistedState?.displayEndDate ? new Date(persistedState.displayEndDate) : "");
    const [viewAsCustomer, setViewAsCustomer] = useState(false);
    const [trendData, setTrendData] = useState(persistedState?.trendData || null);
    const [trendColumns, setTrendColumns] = useState(persistedState?.trendColumns || []);
    const [batchList, setBatchList] = useState(persistedState?.batchList || []);
    const [tagsList, setTagsList] = useState([]);
    const [selectedTags, setSelectedTags] = useState(persistedState?.selectedTags || []);
    const [tagOperator, setTagOperator] = useState(persistedState?.tagOperator || 'OR');
    const [infoPopupVisible, setInfoPopupVisible] = useState(false);



    const navigate = useNavigate();

    useEffect(() => {
        refreshToken();
        getUserAccess();
        getUserCompany();
    }, []);

    useEffect(() => {
        if(role > 2 && cid && !persistedState){
            setSelectedValue(cid);
        }
    },[role, cid, persistedState]);

    useEffect(()=>{
        if(selectedValue && token){
            getCustomerCASAccess(); 
            // getCiaCallHistoryDate();
            getTags();           
        }
    },[selectedValue, access, token]);

    useEffect(()=>{
        if(selectedValue){
            if (role <= 2) { // Admin-like roles who can "view as customer"
                const localStorageKey = `viewAsCustomer_${selectedValue}`;
                const storedValue = localStorage.getItem(localStorageKey);
                if (storedValue !== null) {
                    setViewAsCustomer(JSON.parse(storedValue));
                } else {
                    setViewAsCustomer(false); // Default for admin if not found in localStorage
                }
            } else { // Non-admin roles
                setViewAsCustomer(false); // Non-admins cannot view as customer
            }          
        }else{
            setViewAsCustomer(false);
        }
    },[selectedValue,  role]);

   

    const refreshToken = async () => {
        try {
            const response = await axios.get(`${baseUrl}/token`);
            
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            setRole(decoded.role);
            setName(decoded.name);
            setExpire(decoded.exp);
            setCid(decoded.cid)
        } catch (error) {
           
            if (error.response) {
                // setError("Unauthorized");
                navigate("/");  
                window.location.reload();
            }
        }
    }

    const getUserAccess = async () => {
        try {
            const response = await axiosJWT.get(`${baseUrl}/user-access`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }       
            });
           
            setAccess(response.data.results);
            
        } catch (error) {
           console.log(error);
        }
    }

    const getUserCompany = async () => {
        
        const response = await axiosJWT.get(`${baseUrl}/active-user-company`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        const allArray = response.data.filter(item => item.id !== 1);
        setCompany(allArray);
    }
    const axiosJWT = axios.create();
 
    axiosJWT.interceptors.request.use(async (config) => {
        const currentDate = new Date();
        if (expire * 1000 < currentDate.getTime()) {
            const response = await axios.get(`${baseUrl}/token`);
            config.headers.Authorization = `Bearer ${response.data.accessToken}`;
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            setName(decoded.name);
            setExpire(decoded.exp);
            // setCid(decoded.cid)
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });

    const gotoSwitchScreen = (e) => {
        e.preventDefault();
        const state = { state: {compid : selectedValue, batch_id: batch_id}}
        navigate("/cas-management", state);
    }

    const handleCompanyChange = (e) => {
        setSelectedValue(e.target.value);
        clearFilter();

    };

    const getTags = async () => {
        if (!selectedValue) return;
        try {
            const response = await axiosJWT.get(`${baseUrl}/tags-list?cid=${selectedValue}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setTagsList(response.data.data);
        } catch (error) {
            console.error("Error fetching tags:", error);
        }
    };

    const getCustomerCASAccess = async () => {
        try {
            setPopupOpen(true);
            const response = await axios.get(`${baseUrl}/check-company-e911-access/${selectedValue}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }       
            });
            
            if (role > 2 && (response.data.user_enms_access === 0 || response.data.cia_enable_switch === 0 || (response.data.cia_enable_switch === 1 && response.data.cia_account_type!== 1))) {
                navigate('/dashboard');
                return;
            }
            console.log(response.data);
            if(response.data.cia_enable_switch === 1){
                if(response.data.cia_account_type === 0 && role > 2){
                        setCASAccess(false)
                        setShowNoMessageAccess(true)
                }else{
                    setShowNoMessageAccess(false);
                    setCASAccess(true)
                    
                }
            }else{
                setCASAccess(false)
                setShowNoMessageAccess(true)
            }
            setPopupOpen(false);
        } catch (error) {
           console.log(error);
        }
    };

    const handleSearchDate = (date) => { 
        console.log(date);  
        const formattedDate =
        date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' +
         date.getDate().toString().padStart(2, '0');
      
         
        setSearchDate(formattedDate);
        setDisplayDate(date);
        
    };
    const handleSearchEndDate = (date) => { 
        console.log(date);  
        const formattedDate =
        date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' +
         date.getDate().toString().padStart(2, '0');
      
         
        setSearchEndDate(formattedDate);
        setDisplayEndDate(date);
        
    };
    const handleSearchSubmit = async() => {
        const newErrors = {};
        if (!searchDate) {
            alert('From Date is required.');
            return;
        }
        if (!searchEndDate) {
            alert('To Date is required.');
            return;
        }


        if (Object.keys(newErrors).length === 0) {
            console.log("Validation successful, proceeding with search...");
            console.log(searchDate, searchEndDate, selectedValue);
            setPopupOpen(true);
            const response = await axios.post(`${baseUrl}/get-publish-batch-list`, {company_id:selectedValue, searchDate:searchDate, searchEndDate:searchEndDate},{
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setPopupOpen(false);
            const allBatches = response.data.totalBatch.slice(0, 6);
            const batchCount = allBatches.length;
            setBatchList(allBatches);
            if (batchCount < 2 || batchCount > 6) {
                alert(`Date ranges can only include 2-6 batches. The selected date range includes ${batchCount} batches. Please adjust the date range.`);
                return;
            }else{

                setPopupOpen(true);
                const trendsResponse = await axios.post(`${baseUrl}/get-enrms-summary-comparison`, {batches: allBatches, tags: selectedTags, tagOperator: tagOperator}, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    },
                })
                const trends = trendsResponse.data.trends;               
                setPopupOpen(false);
                if (trends && Object.keys(trends).length > 0) {
                    const firstRowKey = Object.keys(trends).find(key => key !== 'Total');
                    const columns = Object.keys(trends[firstRowKey] || {}).sort((a, b) => a === 'Total' ? 1 : b === 'Total' ? -1 : a.localeCompare(b));
                    setTrendColumns(columns);
                    setTrendData(trends);
                } else {
                    setTrendData(null);
                    alert("No trend data could be generated for the selected batches.");
                }
            }

        }
    };

    const clearFilter = () => {
       
        setSearchDate("");
        setSearchEndDate("");
        setDisplayDate("");
        setDisplayEndDate("");
        setTrendData(null);
        setTrendColumns([]);
        setBatchList([]);
        setSelectedTags([]);
        setTagOperator('OR');
    }

    const handleSummaryTagsChange = (data) => {
        setSelectedTags(data);
    };

    const handleSummaryTagOperator = (e) => {
        setTagOperator(e.target.value);
    };

    const handleCellClick = (category, carrierPlatform) => {
        if (category === 'Total') return;

        // If the 'Total' column is clicked, we use a special identifier for the backend.
        const platformIdentifier = carrierPlatform === 'Total' ? 'All' : carrierPlatform;

        navigate('/enrms-device-comparison', {
            state: {
                compid: selectedValue,
                category,
                carrierPlatform: platformIdentifier,
                batches: batchList,
                tags: selectedTags,
                tagOperator: tagOperator,
                persistedState: {
                    selectedValue,
                    searchDate,
                    searchEndDate,
                    displayDate: displayDate ? displayDate.toISOString() : null,
                    displayEndDate: displayEndDate ? displayEndDate.toISOString() : null,
                    trendData,
                    trendColumns,
                    batchList,
                    selectedTags,
                    tagOperator,
                    compid: selectedValue
                }
            }
        });
    };

    const gotoDetailComparison = () => {
        navigate('/enrms-detail-comparison', {
            state: {
                compid: selectedValue,
                batches: batchList,
                tags: selectedTags,
                tagOperator: tagOperator,
                // Pass the filters so we can come back
                persistedState: {
                    selectedValue,
                    searchDate,
                    searchEndDate,
                    displayDate: displayDate ? displayDate.toISOString() : null,
                    displayEndDate: displayEndDate ? displayEndDate.toISOString() : null,
                    trendData,
                    trendColumns,
                    batchList,
                    selectedTags,
                    tagOperator,
                    compid: selectedValue
                }
            }
        });
    };

    return (
        <div className="panelbox">
            <Navbar token={token} access={access}/>
            <div className="right-panel">
                <Header name={name} />
                {popupOpen && (
                    <Loader /> 
                ) }
                <div className="content-page admin-attendance-page">
                    <div className="row">
                        <div className="col-8">
                            <div className="left-title">
                                <h1>E-NRMS Summary Comparison</h1>
                            </div>
                        </div>
                        <div className="col-4 inventory-btn">                      
                            <div className="addnew-button">
                            <a href="#" onClick={(e) => gotoSwitchScreen(e)}>Back</a>
                            {trendData && <button style={{marginLeft : '10px'}} className="search-btn" onClick={gotoDetailComparison}>Detail Comparison</button>}
                            </div>
                        </div>
                    </div>
                    {(role <= 2) && <div className="common-white-shadow-background setting-section">
                        <div className="row">
                            <h3 className='comapny-label'>Select Company</h3>
                            <div className="inputbox">
                                <select name="" id=""  value={selectedValue} onChange={(e) => handleCompanyChange(e)}>
                                    <option value="">Select Company</option>
                                    {company.map((comp) => ( 
                                            <option key={comp.id} value={comp.id}>
                                                {comp.cname}
                                            </option>  
                                        ))}
                                </select>
                            </div>
                        </div>
                    </div>}
                    {showNoAccessMessage && 
                    <div className="common-white-shadow-background setting-section">
                        <div className="row error">You don't have access to the features.</div>
                    </div>}

                    {selectedValue && casAccess && <>
                        <div className='common-white-shadow-background setting-section'>
                            <div className='row'>
                                <div className='col-md-12 order-filter transection-filter'>
                                    <div className='boxinput'>
                                        <div className='date-picker-container'>
                                        <DatePicker
                                            selected={displayDate}
                                            onChange={handleSearchDate}
                                            dateFormat="MM/dd/yyyy" // Set the desired date format
                                            placeholderText="From Date"
                                            className="from-date"
                                        />
                                        
                                        </div>
                                        <div className='date-picker-container'>
                                        <DatePicker
                                            selected={displayEndDate}
                                            onChange={handleSearchEndDate}
                                            dateFormat="MM/dd/yyyy" // Set the desired date format
                                            placeholderText="To Date"
                                            className="end-date"
                                        />    
                                       
                                        </div>
                                        <div style={{"width":'15%', 'marginLeft':'10px'}}>
                                            
                                            <Select

                                                classNamePrefix="select"
                                                name="tags"
                                                placeholder="Select Tag"
                                                className='search-select enrms-summary-tags'
                                                onChange={(selectedOption)=>{
                                                    handleSummaryTagsChange(selectedOption)
                                                }}
                                                value={selectedTags}
                                                options={ tagsList?.map(item => ({
                                                    value: item.id,
                                                    label: item.tag_name                                                
                                                }))}
                                                isMulti
                                                
                                            
                                            />
                                        </div>
                                        {selectedTags.length > 1 && (
                                            <select style={{ width: 'auto' }} className="form-control" name="tag_operator" value={tagOperator} onChange={handleSummaryTagOperator}>
                                                <option value="AND">AND</option>
                                                <option value="OR">OR</option>
                                            </select>
                                        )}

                                        <button  style={{marginLeft : '20px'}} className="search-btn" onClick={handleSearchSubmit}>Search</button> 
                                        { ( searchDate || searchEndDate || selectedTags.length > 0) && (
                                            <a className='search-btn clear-btn' onClick={clearFilter} >Clear</a>
                                        )}
                                    </div>
                                    
                                </div>
                            </div>
                            <div>
                            {trendData && trendColumns.length > 0 && (
                                <>
                            {/* <div className="common-white-shadow-background setting-section"> */}
                                <h3>
                                    Summary Results
                                    {/* <span className="info-icon-container" style={{marginLeft: '8px', cursor: 'pointer', color: '#007bff'}}>
                                        <i className="fas fa-info-circle" onClick={() => setInfoPopupVisible(true)}></i>
                                    </span> */}
                                    <span><img src={`${process.env.PUBLIC_URL}/images/view.png`}  onClick={() => setInfoPopupVisible(true)} style={{ cursor: 'pointer' }} /></span>                                       
                                </h3>
                                {infoPopupVisible && (
                                    <div className="info-popup-overlay" style={{position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000}} onClick={() => setInfoPopupVisible(false)}>
                                        <div className="info-popup-content" style={{background: 'white', padding: '20px 30px', borderRadius: '8px', maxWidth: '600px', width: '90%', position: 'relative'}} onClick={(e) => e.stopPropagation()}>
                                            <button className="close-btn" style={{position: 'absolute', top: '10px', right: '15px', background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer'}} onClick={() => setInfoPopupVisible(false)}>&times;</button>
                                            <h4>Summary Comparison Definitions</h4>
                                            <ul style={{listStyleType: 'none', paddingLeft: 0}}>
                                                <li style={{marginBottom: '12px', lineHeight: 1.5}}><strong>General:</strong> Only numbers which appear in at least 2 batches will appear in the comparison.</li>
                                                <li style={{marginBottom: '12px', lineHeight: 1.5}}><strong>All Normal:</strong> The number is "Normal" for all batches in the date range.</li>
                                                <li style={{marginBottom: '12px', lineHeight: 1.5}}><strong>Improved:</strong> The number is "Normal" for the most recent batch in the date range, but is not "Normal" for one or more of the other batches in the date range.</li>
                                                <li style={{marginBottom: '12px', lineHeight: 1.5}}><strong>Declined:</strong> The number is "Spam" or "Unknown" for the most recent batch in the date range, but is "Normal" for one or more of the other batches in the date range.</li>
                                                <li style={{marginBottom: '12px', lineHeight: 1.5}}><strong>Mult Unknown:</strong> The number is "Unknown" for the most recent batch and also for other batches in the date range.</li>
                                                <li style={{marginBottom: '12px', lineHeight: 1.5}}><strong>Mult Spam:</strong> The number is "Spam" for the most recent batch and also for other batches in the date range.</li>
                                                <li style={{marginBottom: '12px', lineHeight: 1.5}}><strong>Incomplete:</strong> The number is in all batches in the date range, but in some batches the number does not have results for all carriers/platforms.</li>
                                                <li style={{marginBottom: '12px', lineHeight: 1.5}}><strong>Total Column:</strong> Each number is only counted once. Therefore, a number which has different results across different carriers/platforms will cause the "Total" column to not always match the sum of the other columns in the row. For example, a number which is "Improved" for one carrier/platform but which is "Declined" for another carrier/platform will appear in the overall Total column as a "Decline".</li>
                                            </ul>
                                        </div>
                                    </div>
                                )}
                                <div className="setting-section haft-whitebox cia-table">
                                    <table className="tablebox search-result-table inventory-table">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                {trendColumns.map(col => <th key={col}>{col.replace(/_/g, ' ')}</th>)}
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {Object.keys(trendData).filter(key => key !== 'No Data').map(rowKey => ( 
                                            <tr key={rowKey} style={{ fontWeight: rowKey === 'Total' ? 'bold' : 'normal' }}>
                                                <td><strong>{rowKey}</strong></td>{trendColumns.map(colKey => (<td key={`${rowKey}-${colKey}`}>
                                                {(trendData[rowKey][colKey] > 0 && rowKey !== 'Total') ? (
                                                    <a href="#" onClick={(e) => { e.preventDefault(); handleCellClick(rowKey, colKey); }}>
                                                        {trendData[rowKey][colKey]}
                                                    </a>
                                                ) : (
                                                    trendData[rowKey][colKey]
                                                )}
                                                </td>)) }
                                            </tr>))}
                                        </tbody>
                                    </table>
                                </div>
                            {/* </div> */}
                            <TrendAnalysisChart trendData={trendData} trendColumns={trendColumns} />
                            </>
                        )}
                            </div>
                        </div>
                    </>}
                </div>
            </div>
        </div>
    );

}

export default ENRMSSummaryComparison;